export default __webpack_public_path__ + "static/media/redBig.20ce0813.svg";